module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stayFun),
      expression: "stayFun"
    }],
    staticClass: "page-funreport",
    on: {
      "touchmove": function($event) {
        _vm.loadMoreFriend()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.funreport.pic.replace('../', './')
    }
  }), _vm._v(" "), _c('fun-head'), _vm._v(" "), _c('fun-report'), _vm._v(" "), _c('div', {
    staticClass: "funreport-actions"
  }, [(!_vm.is_free & !_vm.shareLock) ? _c('div', [_c('p', {
    staticClass: "unlock-tips"
  }, [_vm._v("好奇的，来打赏" + _vm._s(_vm.price) + "元")]), _vm._v(" "), _c('p', {
    staticClass: "unlock-tips"
  }, [_vm._v("心理学家深度解读你的性格、爱情、职场特质")]), _vm._v(" "), _c('a', {
    staticClass: "btn mg0",
    on: {
      "click": function($event) {
        _vm.buyReport()
      }
    }
  }, [_vm._v("好的，GO！")])]) : _vm._e(), _vm._v(" "), (_vm.is_free & !_vm.shareLock) ? _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.funToShare()
      }
    }
  }, [_vm._v("限时免费！马上解锁专业报告")]) : _vm._e(), _vm._v(" "), (_vm.is_free & !_vm.shareLock) ? _c('p', {
    staticClass: "unlockPeople"
  }, [_vm._v("已有" + _vm._s(_vm.selfResult.unlock_num) + "人成功解锁专业报告")]) : _vm._e(), _vm._v(" "), (_vm.shareLock) ? _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.toProReport()
      }
    }
  }, [_vm._v("查看专业报告")]) : _vm._e(), _vm._v(" "), (_vm.shareLock) ? _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.toggleShare()
      }
    }
  }, [_vm._v("看看好友的动物画像")]) : _vm._e()]), _vm._v(" "), (_vm.shareLock | !_vm.is_free) ? _c('div', [_c('friend-list')], 1) : _vm._e(), _vm._v(" "), (_vm.shareMask & _vm.shareLock) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.toggleShare()
      }
    }
  }, [_c('unlock-share')], 1) : _vm._e(), _vm._v(" "), (_vm.shareMask & !_vm.shareLock) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.toggleShare()
      }
    }
  }, [_c('free-share')], 1) : _vm._e(), _vm._v(" "), _c('yxl-logo'), _vm._v(" "), (_vm.qrCodeMask & _vm.isFirstShare) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.oneQrcode()
      }
    }
  }, [_c('qrcode-mask')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-5e17e08c!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/funreport.vue
// module id = 134
// module chunks = 2